// extracted by mini-css-extract-plugin
export default {"form":"SignUp_form__oiY++","signUp":"SignUp_signUp__kycNx","input":"SignUp_input__uu2BO","btnLink":"SignUp_btnLink__K1OLw","signup":"SignUp_signup__9F7oC","btn":"SignUp_btn__H+9WN"};